module.exports = __webpack_public_path__ + "img/whatsapp.92f40e4f.svg";